import { render } from "./OverlayMenu.vue?vue&type=template&id=67272132"
import script from "./OverlayMenu.vue?vue&type=script&lang=js"
export * from "./OverlayMenu.vue?vue&type=script&lang=js"

import exportComponent from "/Users/alexanderwesselburg/Projekte/MyPortal/fewo-in-ahrenshoop_v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__